import { Truck } from '@phosphor-icons/react';

export function FreeShippingBanner() {
  return (
    <div className="shipping-banner text-white py-2.5 text-center" data-testid="shipping-banner">
      <div className="flex items-center justify-center gap-2 text-sm font-medium">
        <Truck size={18} weight="bold" />
        <span>Free Shipping on Orders Over $75</span>
      </div>
    </div>
  );
}
